var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisibilityPrevWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 41q-1.2 0-2.05-.85Q7 39.3 7 38.1V9.9q0-1.2.85-2.05Q8.7 7 9.9 7h28.2q1.2 0 2.05.85.85.85.85 2.05v28.2q0 1.2-.85 2.05-.85.85-2.05.85Zm0-2.25h28.2q.3 0 .475-.175t.175-.475V13.25H9.25V38.1q0 .3.175.475t.475.175ZM24 32.8q-3.6 0-6.45-1.875T13.3 26q1.4-3.05 4.25-4.95 2.85-1.9 6.45-1.9t6.45 1.9q2.85 1.9 4.3 4.95-1.45 3.05-4.3 4.925Q27.6 32.8 24 32.8Zm0-2q2.6 0 4.85-1.275Q31.1 28.25 32.5 26q-1.35-2.25-3.625-3.525T24 21.2q-2.6 0-4.875 1.275T15.5 26q1.4 2.25 3.65 3.525T24 30.8Zm0-2.55q-.95 0-1.6-.675-.65-.675-.65-1.575 0-.95.675-1.6.675-.65 1.575-.65.95 0 1.6.675.65.675.65 1.575 0 .95-.675 1.6-.675.65-1.575.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityPrevWhite);
export default __webpack_public_path__ + "static/media/ic_visibility_prev_white.65f9306b802e8dbc954aa1a71d3cfb90.svg";
export { ForwardRef as ReactComponent };